module.exports = __webpack_public_path__ + "static/circularstd-bold-fdbfc358bc6e87a42b57707567214dc6.woff2";